var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-logo-text",class:[ ("_variant_" + _vm.variant), {
        _colored: _vm.useCurrentColor,
        _light: _vm.light,
        _big: _vm.big,
    }]},[_c('span',{staticClass:"ui-logo-text__simple",style:(_vm.firstColor ? { color: _vm.firstColor } : null),domProps:{"textContent":_vm._s('Simple')}}),_c('span',{staticClass:"ui-logo-text__estate",style:(_vm.secondColor ? { color: _vm.secondColor } : null),domProps:{"textContent":_vm._s('Estate')}})])}
var staticRenderFns = []

export { render, staticRenderFns }